import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { TcsmStates } from '../../root/tcsm-model';
import { BillingAccountsNavEn, BillingAccountsNavSp } from '../constants/navigation-lists';
import { DropdownNavigation } from './dropdown-navigation';

export interface Props {
	basePath: string;
}

export function BillingAccountNav(props: Props){

	const language = useSelector<TcsmStates, string>(state => state.globalization.currentlanguage);
	const navOptions = language === 'en' ? BillingAccountsNavEn(props.basePath) : BillingAccountsNavSp(props.basePath);
	const location = useLocation();

	const pathName = location.pathname.toLocaleLowerCase();

	if (!navOptions.some(a => pathName === a.value?.toLocaleLowerCase() || pathName === a.fallbackMatch?.toLocaleLowerCase())) {
		return null;
	}

	return (
		<DropdownNavigation options={navOptions} />
	);
}